import { useContext } from 'react';
import { FlowCoreContextGetterI, FlowCoreContextI } from 'types/flowCore.types';

import { FlowCoreContext } from './FlowCoreContext';

/**
 * Flow Core hooks APIs
 */

export const useFlowCore = (): FlowCoreContextI => {
  const flowCoreContext = useContext(FlowCoreContext);
  return flowCoreContext;
};

export const useFlowMode = (): [FlowCoreContextI['start'], FlowCoreContextI['stop']] => {
  const flowCoreContext = useContext(FlowCoreContext);
  return [flowCoreContext.start, flowCoreContext.stop];
};

export const useFlowCoreValue = <T extends keyof FlowCoreContextGetterI>(key: T) => {
  const flowCoreContext = useContext(FlowCoreContext);
  return flowCoreContext[key];
};
